import React, { useContext } from 'react'
import { useTranslation, Trans } from 'react-i18next'
import { getReferrerVertical } from 'lib/verticalReferrer'
import { graphqlPrevLocationCached } from 'lib/utils/store/navHistory'
import { flowRight } from 'lodash'
import { urlWithLangParam } from 'lib/helpers'
import { getLocale } from 'lib/utils/getLocale'

import { DevErrorViewContext } from 'components/Errors/DevErrorView'
import ErrorMessageContent from './ErrorMessageContent'
import Link from 'components/Link'

const DEV_TEST_DATA = {
    errors: {
        vehicleRestriction: 'Vehicle can\'t have any restrictions',
    },
    adUrl: 'https://nettiauto.com',
}

const FinancingApplicationTraficomCheckErrorMessages = ({ appError, prevLocation }) => {
    const { t, i18n } = useTranslation()

    const devErrorContext = useContext(DevErrorViewContext)

    let data = appError.data

    if (devErrorContext) {
        data = DEV_TEST_DATA
    }

    return (
        <ErrorMessageContent
            title={t(`errors:omanettix.${appError.code}.title`)}
            content={(
                <>
                    <p>{t(`errors:omanettix.${appError.code}.${Object.keys(data.errors)[0]}.message`)}</p>
                    <p>
                        <Trans i18nKey={`errors:omanettix.${appError.code}.financeAnotherVehicleTip`}>
                            Voit halutessasi <Link to={`${getLocale(i18n.language)}/autorahoitus`} trackName="financeAnotherVehicle">hakea rahoitusta toiselle ajoneuvolle.</Link>
                        </Trans>
                    </p>
                </>
            )}
            actions={data.adUrl && (
                <Link
                    to={urlWithLangParam(data.adUrl, i18n.language)}
                    className="button"
                    target="_self"
                    onClick={(e) => {
                        const referrerVertical = getReferrerVertical(document.referrer)

                        // act as browser back button in case we just arrived to omanettix (from vertical)
                        if (referrerVertical && !prevLocation && window.history.length > 1) {
                            e.preventDefault()
                            window.history.back()
                        }
                    }}
                >
                    {t(`errors:omanettix.${appError.code}.backToAd`)}
                </Link>
            )}
        />
    )
}

export default flowRight(
    graphqlPrevLocationCached,
)(FinancingApplicationTraficomCheckErrorMessages)
